import { render, staticRenderFns } from "./collegeClassDelete.vue?vue&type=template&id=d44d1f4c&"
import script from "./collegeClassDelete.vue?vue&type=script&lang=js&"
export * from "./collegeClassDelete.vue?vue&type=script&lang=js&"
import style0 from "./collegeClassDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports